import type React from "react"
import styles from "./ToggleSlider.module.scss"

interface ToggleSliderProps {
  isActive: boolean
  onChange: (isActive: boolean) => void
  disabled?: boolean
  size?: "sm" | "md"
}

const ToggleSlider: React.FC<ToggleSliderProps> = ({ isActive, onChange, disabled = false, size = "md" }) => {
  return (
    <button
      type="button"
      className={`${styles.toggleSlider} ${isActive ? styles.active : ""} ${disabled ? styles.disabled : ""} ${size === "sm" ? styles.small : ""}`}
      onClick={() => !disabled && onChange(!isActive)}
      disabled={disabled}
      aria-checked={isActive}
      role="switch"
    >
      <span className={styles.slider} />
    </button>
  )
}

export default ToggleSlider